// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursor-pointer[data-v-4bdca7f0]{cursor:pointer}.gap-2[data-v-4bdca7f0]{gap:8px}", ""]);
// Exports
module.exports = exports;
